export function toCurrencyPrototype(options) {
    const value = this;
    const currencyConfig = {
        style: 'currency',
        currency: 'BRL',
        maximumFractionDigits: options?.noFractions ? 0 : 2,
    };
    let currencyValue = Number(value).toLocaleString('pt-br', currencyConfig);
    if (options?.removeSpace) {
        currencyValue = currencyValue.replace(/\s/g, '');
    }
    if (options?.operator) {
        currencyValue = `${options.operator} ${currencyValue}`;
    }
    if (!Number.isFinite(Number(value))) {
        return Number(0).toLocaleString('pt-br', currencyConfig).replaceAll(String.fromCharCode(160), ' ');
    }
    return currencyValue.replaceAll(String.fromCharCode(160), ' ');
}
//# sourceMappingURL=toCurrency.js.map